import { useTranslation } from "react-i18next";
import classes from "./TrainingConsentInfo.module.less";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import Modal from "~/common/components/Modal";
import classNames from "classnames";
import { useIsMinDesktopSize, useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { Button } from "~/common/mui";
import { LMS_TRAINING_OVERVIEW_URL } from "~/utils/url/staticUrls";
import { useEffect } from "react";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { Snackbar, SnackbarCloseButton } from "~/common/mui/Snackbar/Snackbar";

interface TrainingConsentInfoProps {
  modal: boolean;
  closeModal: () => void;
  hideSnackbar?: boolean;
  loading?: boolean;
  onActivated?: (() => void) | (() => Promise<void>);
  className?: string;
}

const TrainingConsentInfo = ({ modal, closeModal, hideSnackbar, loading, onActivated }: TrainingConsentInfoProps) => {
  const { t } = useTranslation();

  const { val: profileSnackbar, setTrue: showProfileSnackbar, setFalse: hideProfileSnackbar } = useBooleanState(false);

  const isMinTablet = useIsMinTabletSize();
  const isMinDesktop = useIsMinDesktopSize();

  useEffect(() => {
    if (modal) {
      window.sessionStorage.setItem("persistConsentInfoModal", "true");
      if (history.scrollRestoration) {
        history.scrollRestoration = "manual";
      }
    }
  }, [modal]);

  const overrideModal = window.sessionStorage.getItem("persistConsentInfoModal") === "true" ? true : false;

  const handleModalClose = () => {
    window.sessionStorage.setItem("persistConsentInfoModal", "false");
    closeModal();
  };

  return (
    <>
      {!hideSnackbar && (
        <Snackbar
          open={profileSnackbar}
          onClose={hideProfileSnackbar}
          message={t("myAccount.training.activated")}
          action={<SnackbarCloseButton onClick={hideProfileSnackbar} />}
        />
      )}

      {(overrideModal || modal) && (
        <Modal
          hideClose
          onClose={handleModalClose}
          footerChildren={
            <div className={classes.buttons}>
              {loading ? (
                <CircleSpinner className={classes.spinner} />
              ) : (
                <Button
                  fullWidth={!isMinDesktop}
                  onClick={async () => {
                    await onActivated?.();
                    window.open(LMS_TRAINING_OVERVIEW_URL, "_blank");
                    handleModalClose();
                    showProfileSnackbar();
                  }}
                >
                  {t("myAccount.training.activateProfile")}
                </Button>
              )}
            </div>
          }
        >
          <div className={classNames(classes.modal, !isMinTablet && classes.fullscreenModal)}>
            <h3 className="f-18">{t("myAccount.training.thankYou")}</h3>
            <p>{t("myAccount.training.message")}</p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default TrainingConsentInfo;
